export default {"src":"/_next/static/media/icon-flag-french.34768220.svg","height":27,"width":40,"blurWidth":0,"blurHeight":0};